import { defineStore } from 'pinia';
import { computed, shallowReactive } from 'vue';

import { useResourceList } from '../composables/request.ts';
import { models, Notification } from '../models.ts';
import { payload } from '../payload.ts';

export const useGlobalStore = defineStore('global', {
    state: () => ({
        appName: payload.appName,
        notifications: shallowReactive(useResourceList<Notification>()),
    }),

    getters: {
        actor: () => models.find('users', payload.userId),
        isAdmin: (state) => state.appName === 'admin',
    },
});

export const useActor = () => computed(() => useGlobalStore().actor!);

export const useIsAdminApp = () => computed(() => useGlobalStore().isAdmin);
